(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bw-apparel-collection"] && !Shopify.designMode) return;
  try {
    function bwApparelLabels() {
    var panel = document.querySelector('[data-bw-apparel]');
    if (!panel) return;
    [['Vendor',panel.dataset.brandLabel],['Product type',panel.dataset.typeLabel]].forEach(function(pair) {
      document.querySelectorAll('[data-filter-name="'+pair[0]+'"] .cloud-search-filter__name').forEach(function(label) {
        if(label.textContent !== pair[1]) label.textContent = pair[1];
      });
    });
    panel.querySelectorAll('a').forEach(function(link) {
      var target = new URL(link.href);
      if(target.pathname === location.pathname && target.search === location.search) link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    });
  }
  bwApparelLabels();
  var bwApparelPending = false;
  new MutationObserver(function() {
    if(bwApparelPending) return;
    bwApparelPending = true;
    requestAnimationFrame(function(){bwApparelPending=false;bwApparelLabels();});
  }).observe(document.body,{childList:true,subtree:true});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-apparel-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    document.querySelectorAll('.bw-apparel-details[open]').forEach(function(menu) {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') document.querySelectorAll('.bw-apparel-details[open]').forEach(function(menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
